import { type DocNode } from '@atlaskit/adf-schema/doc';
import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { addAssistantMessage } from './addAssistantMessage';
import { createSafeAction, type SafeAction } from './createSafeAction';
import { generateId } from './generateId';
import type { ChatStoreAction } from './types';

type AddAgentMessageArgs = {
	agentNamedId: string;
	conversationId: string;
	content: string | DocNode;
};

export const addAgentMessage: SafeAction<[AddAgentMessageArgs]> = createSafeAction(
	StoreActionLoggableName.addAgentMessage,
	({ conversationId, agentNamedId, content }: AddAgentMessageArgs): ChatStoreAction =>
		({ dispatch }) => {
			dispatch(
				addAssistantMessage({
					id: generateId(),
					content,
					conversationId,
					agentNamedId,
				}),
			);
		},
);
